import * as _ from 'lodash';

export default {
    title: 'Error rate',
    chartSettings: {
        type: 'line',
        height: 300,
        options: {
            responsive: true,
            maintainAspectRatio:false,
            legend: {
                display: false
            }
        },
        data: {
            backgroundColor: 'red'
        }
    },
    mapData(data){
        return {
            labels: _.map(data, 'time'),
            datasets: [{
                backgroundColor: "#f57c00",
                data: _.map(data, 'count')
            }]
        }
    },
    fetchDataFn: 'getErrorRate'

}


// WEBPACK FOOTER //
// ./src/components/stats/charts/commonWidgetSettings/errorRate.settings.js